import React, { useEffect, useState, useRef, useCallback } from "react";
import { useGlobalData } from "../context/GlobalDataContext";
import { Link } from "react-router-dom";
import "./AnswerKeyTablePage.css";

const TABLE_PAGE_LIMIT = 29;


function AnswerKeyTablePage() {
  const { threeTable, fetchThreeTableSection } = useGlobalData();
  const [isUpdating, setIsUpdating] = useState(false);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [localAnswerKeys, setLocalAnswerKeys] = useState([]);
  // Removed unused initialLoadDone state
  const tableWrapperRef = useRef(null);

  // Initial + paginated load
  const loadAnswerKeys = useCallback(async (nextOffset = 0, isInitial = false) => {
    setIsUpdating(true);
    try {
      await fetchThreeTableSection("answerKeys", false, {
        preferLoadedData: false,
        fetchIfPartial: false,
        showLoading: false,
        skipLoader: !isInitial,
        limit: TABLE_PAGE_LIMIT,
        offset: nextOffset
      });
      setHasMore(true);
      setOffset(nextOffset);
      // Removed setInitialLoadDone as it's unused
    } finally {
      setIsUpdating(false);
    }
  }, [fetchThreeTableSection]);

  useEffect(() => {
    if (offset === 0) {
      setLocalAnswerKeys(threeTable.answerKeys || []);
      setHasMore((threeTable.answerKeys || []).length === TABLE_PAGE_LIMIT);
      setOffset((threeTable.answerKeys || []).length);
    }
  }, [threeTable.answerKeys, offset]);


  // On mount: agar global state me data hai to wahi use karo, warna API call karo (aur skeleton dikhao)
  useEffect(() => {
    if ((threeTable.answerKeys || []).length > 0) {
      setLocalAnswerKeys(threeTable.answerKeys);
      setHasMore(threeTable.answerKeys.length === TABLE_PAGE_LIMIT);
      setOffset(threeTable.answerKeys.length);
      // Removed setInitialLoadDone as it's unused
    } else {
      loadAnswerKeys(0, true); // skipLoader: false for skeleton
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!hasMore || isUpdating) return;
      const el = tableWrapperRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      if (rect.bottom <= window.innerHeight + 200) {
        loadAnswerKeys(offset, false); // skipLoader: true for scroll
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasMore, isUpdating, offset, loadAnswerKeys]);

  const answerKeys = localAnswerKeys;
  const jobs = threeTable.jobs || [];
  // ✅ Get job title by slug
  const getJobTitle = (jobSlug) => {
    const job = jobs.find((j) => j.slug === jobSlug);
    return job ? job.title : jobSlug;
  };
  return (
    <div className="answerkey-table-container">
      <h2>Answer Key Table</h2>
      <div
        className="answerkey-table-wrapper"
        ref={tableWrapperRef}
        style={{ overflowY: "auto", maxHeight: "1400px" }}
      >
        <table className="answerkey-table">
          <thead>
            <tr>
              <th>Job Title</th>
              <th>View</th>
            </tr>
          </thead>
          <tbody>
            {answerKeys.map((item, i) => (
              <tr key={i}>
                <td>{getJobTitle(item.jobSlug)}</td>
                <td>
                  <Link to={`/mform/${item.jobSlug}`}>Answer Key View</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Status messages below the table */}
      {isUpdating && answerKeys.length === 0 && (
        <p style={{ marginTop: "10px", textAlign: "center", color: "#1d4ed8", fontWeight: 600 }}>
          Loading answer keys...
        </p>
      )}
      {isUpdating && answerKeys.length > 0 && (
        <p style={{ marginTop: "10px", textAlign: "center", color: "#1d4ed8", fontWeight: 600 }}>
          Loading more answer keys...
        </p>
      )}
      {!isUpdating && !hasMore && answerKeys.length > 0 && (
        <p style={{ marginTop: "10px", textAlign: "center", color: "#888" }}>
          No more answer keys.
        </p>
      )}
    </div>
  );
}

export default AnswerKeyTablePage;
